import { createFileRoute } from '@tanstack/react-router'

import { StoreCategoryPage } from '@/features/store'

export const Route = createFileRoute(
  '/_authenticated/_main/loja/categorias/$categoryId'
)({
  component: StoreCategoryRoute
})

function StoreCategoryRoute() {
  const { categoryId } = Route.useParams()
  return <StoreCategoryPage categoryId={Number(categoryId)} />
}
